import React from 'react';
import { X, AlertTriangle, CheckCircle, HelpCircle } from 'lucide-react';
import '../../styles/RekapDataDetails.css';

const modalTypes = {
  error: {
    headerClass: 'survey-header-error',
    icon: <AlertTriangle size={24} />,
    confirmText: 'Mengerti',
    confirmClass: 'btn-submit',
    title: 'Terjadi Kesalahan'
  },
  success: {
    headerClass: 'survey-header-success',
    icon: <CheckCircle size={24} />,
    confirmText: 'OK',
    confirmClass: 'btn-success',
    title: 'Berhasil'
  },
  confirm: {
    headerClass: 'survey-header survey-header-confirm',
    icon: <HelpCircle size={24} />,
    confirmText: 'Ya, Lanjutkan',
    cancelText: 'Batal',
    confirmClass: 'btn-confirm',
    title: 'Konfirmasi'
  },
  danger: {
    headerClass: 'survey-header-error',
    icon: <AlertTriangle size={24} />,
    confirmText: 'Ya, Hapus',
    cancelText: 'Batal',
    confirmClass: 'btn-danger',
    title: 'Peringatan'
  },
  logout: {
    headerClass: 'survey-header-logout',
    icon: <HelpCircle size={24} />,
    confirmText: 'Ya, Keluar',
    cancelText: 'Batal',
    confirmClass: 'btn-logout',
    title: 'Konfirmasi Keluar'
  }
};

const Modal = ({
  isOpen,
  onClose,
  type = 'error',
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  showCancel = false
}) => {
  const config = modalTypes[type];
  const shouldShowCancel = type === 'confirm' || type === 'danger' || type === 'logout' || showCancel;

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
    if (e.key === 'Enter' && !shouldShowCancel) {
      if (onConfirm) {
        onConfirm();
      } else {
        onClose();
      }
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen, shouldShowCancel, onClose, onConfirm]);

  if (!isOpen) return null;

  return (
    <div className="survey-modal-overlay" onClick={handleBackdropClick}>
      <div className="survey-modal" style={{ maxWidth: '480px' }}>
        <div className={config.headerClass}>
          <div className="survey-header-content">
            <div className="survey-icon">
              {config.icon}
            </div>
            <div>
              <h3>{title || config.title}</h3>
              {type === 'error' && (
                <p>Silakan coba lagi atau hubungi administrator</p>
              )}
              {type === 'success' && (
                <p>Operasi berhasil dilakukan</p>
              )}
              {type === 'confirm' && (
                <p>Pastikan tindakan yang akan dilakukan</p>
              )}
              {type === 'danger' && (
                <p>Tindakan ini tidak dapat dibatalkan</p>
              )}
              {type === 'logout' && (
                <p>Anda akan keluar dari sistem</p>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="survey-close-btn"
            aria-label="Tutup modal"
          >
            <X size={20} />
          </button>
        </div>

        <div className="survey-form" style={{ padding: '25px 30px' }}>
          <div style={{
            fontSize: '15px',
            color: '#374151',
            lineHeight: '1.6',
            marginBottom: shouldShowCancel ? '0' : '10px'
          }}>
            {message || 'Tidak ada pesan yang ditampilkan.'}
          </div>

          <div className="form-actions" style={{
            paddingTop: '15px',
            marginTop: '20px',
            justifyContent: 'center'
          }}>
            {shouldShowCancel ? (
              <>
                <button
                  onClick={onClose}
                  className="btn-cancel"
                  aria-label="Batal"
                >
                  {cancelText || config.cancelText}
                </button>
                <button
                  onClick={onConfirm}
                  className={config.confirmClass}
                  aria-label="Konfirmasi"
                >
                  {confirmText || config.confirmText}
                </button>
              </>
            ) : (
              <button
                onClick={onConfirm || onClose}
                className={config.confirmClass}
                aria-label="OK"
                autoFocus
              >
                {confirmText || config.confirmText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;